<template>
  <div class="layout-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <el-collapse-item @mousedown.native="collapseMouseDown($event, '1')" title="显示位置" name="1">
          <cx-slider class="rect-active-slider" label="" :value.sync="direction" :options="activeTypeOptions" />
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown($event, '2')" title="基础设置" name="2">
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')"
          >
            <div class="data-item mb8">
              <el-checkbox v-model="showClose">显示“关闭按钮”</el-checkbox>
            </div>
            <div class="data-item mb8" v-if="sourceId === 'notice_drawer'">
              <el-checkbox v-model="showConfirm">显示“确认按钮”</el-checkbox>
            </div>
            <div class="data-item mb8">
              <el-checkbox v-model="maskClosable">点击遮罩关闭抽屉</el-checkbox>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import $ from "jquery"
export default {
  name: "drawer-options-setting",
  props: {
    options: Object
  },
  data() {
    return {
      activeNames: ["1", "2", "3"],
      collapseActiveNames: ["1", "2", "3"],
      activeTypeOptions: [
        { value: "center", title: "居中" },
        { value: "ltr", title: "左侧" },
        { value: "rtl", title: "右侧" },
        { value: "ttb", title: "顶部" },
        { value: "btt", title: "底部" }
      ]
    }
  },
  comments: {},
  components: {},
  directives: {},
  created() {},
  watch: {},
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    direction: {
      get() {
        return this.options.options.drawerParams.direction
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "drawerParams.direction", false)
        let height = 0
        if (newVal === "ltr" || newVal === "rtl") {
          this.$changeOptionsEV(0, "drawerParams.height", false)
          this.$changeOptionsEV(300, "drawerParams.width", false)
        } else if (newVal === "center") {
          let width = 400
          height = 200
          if (this.request_prefix === "appStage") {
            width = 350
            height = 240
          }
          this.$changeOptionsEV(width, "drawerParams.width", false)
          this.$changeOptionsEV(height, "drawerParams.height", false)
        } else {
          height = 300
          this.$changeOptionsEV(0, "drawerParams.width", false)
          this.$changeOptionsEV(300, "drawerParams.height", false)
        }
        this.$nextTick(() => {
          let list = this.$store.state[this.request_prefix].page.pageLayoutList
          // 根据this.options.id找到对应的pageLayoutList
          let pageLayoutList = list.find(it => it.id === this.options.id)
          pageLayoutList.layout.rows[0].options.width = "100%"
          pageLayoutList.layout.rows[0].options.height = height ? height - 6 : $(`.pageLayout_id_${this.options.id}`).parent().height()
          this.$store.dispatch(this.request_prefix + "/changePageLayout", { pageLayoutList: list })
        })
      }
    },
    sourceId() {
      return this.options.options.source_id
    },
    showConfirm: {
      get() {
        return this.options.options.drawerParams.showConfirm
      },
      set(newVal) {
        if (this.options.layout.rows[0].rectIds.length > 0) {
          this.options.layout.rows[0].rectIds.forEach(it => {
            // 找到关闭图标组件
            this.$store.state[this.request_prefix].page.children[0].children.forEach(item => {
              if (item.rect_id === it && item.options?.pluginName?.includes("noticeConfirmPlugin")) {
                if (newVal) {
                  this.$changeOptionsEV(1, "opacity", null, false, {
                    rect_id: item.rect_id,
                    container_id: 0
                  })
                } else {
                  this.$changeOptionsEV(0, "opacity", null, false, {
                    rect_id: item.rect_id,
                    container_id: 0
                  })
                }
              }
            })
          })
        }
        this.$changeOptionsEV(newVal, "drawerParams.showConfirm", false)
      }
    },
    showClose: {
      get() {
        return this.options.options.drawerParams.showClose
      },
      set(newVal) {
        if (this.options.layout.rows[0].rectIds.length > 0) {
          this.options.layout.rows[0].rectIds.forEach(it => {
            // 找到关闭图标组件
            this.$store.state[this.request_prefix].page.children[0].children.forEach(item => {
              if (item.rect_id === it && item.options?.pluginName?.includes("controlDrawerPlugin")) {
                if (newVal) {
                  this.$changeOptionsEV(1, "opacity", null, false, {
                    rect_id: item.rect_id,
                    container_id: 0
                  })
                } else {
                  this.$changeOptionsEV(0, "opacity", null, false, {
                    rect_id: item.rect_id,
                    container_id: 0
                  })
                }
              }
            })
          })
        }
        this.$changeOptionsEV(newVal, "drawerParams.showClose", false)
      }
    },
    maskClosable: {
      get() {
        return this.options.options.drawerParams.maskClosable
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "drawerParams.maskClosable", false)
      }
    }
  },
  methods: {
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    }
  }
}
</script>

<style scoped lang="scss">
.rect-active-slider {
  padding: 8px 0px;
}
</style>
